export const ALPHABETICAL_REG_EXP = new RegExp(/^([A-Za-zÀ-Ÿà-ÿ-'\s])+$/);
